import React from "react";

import { ExecutedPromptMarkdown } from "src/aiNode/components/ExecutedPromptMarkdown";
import {
  compilePromptTemplate,
  ExecutedPromptVariables,
} from "src/aiNode/executedPromptsUtils";
import {
  FloatingWindowInternal,
  useFloatingWindowPosition,
} from "src/base-components/FloatingWindow/FloatingWindow";
import { useFloatingWindowsActions } from "src/base-components/FloatingWindow/hooks";
import { FloatingWindowProps } from "src/base-components/FloatingWindow/store";
import { copyTextToClipboard } from "src/utils/clipboard";

export type ExecutedPromptWindowData = {
  title: string;
  template: string;
  variables: ExecutedPromptVariables;
};

export const ExecutedPromptWindow: React.FC<FloatingWindowProps> = ({
  computePosition,
  id,
  data,
}) => {
  const { close: closeWindow } = useFloatingWindowsActions();
  const { position, windowRef } = useFloatingWindowPosition(computePosition);

  const typedData = data as ExecutedPromptWindowData;

  return (
    <FloatingWindowInternal
      ref={windowRef}
      dataLoc="executed-prompt-window"
      height="h-120"
      id={id}
      style={{
        inset: "0px auto auto 0px",
        transform: position,
      }}
      title={typedData.title}
      width="w-150"
      draggable
      maximizable
      resizeable
      isPinned
      onClose={() => closeWindow(id)}
      onCopy={() =>
        copyTextToClipboard(
          compilePromptTemplate(typedData.template, typedData.variables),
        )
      }
    >
      <div className="decideScrollbar h-full overflow-y-auto p-4 pt-2">
        <ExecutedPromptMarkdown
          template={typedData.template}
          variables={typedData.variables}
        />
      </div>
    </FloatingWindowInternal>
  );
};
